import api from "lib/api/api";

export const TM_TEACHERS_REQUEST = "TM_TEACHERS_REQUEST";
export const TM_TEACHERS_SUCCESS = "TM_TEACHERS_SUCCESS";
export const TM_TEACHERS_FAILURE = "TM_TEACHERS_FAILURE";

export const TM_CREATE_COURSE_REQUEST = "TM_CREATE_COURSE_REQUEST";
export const TM_CREATE_COURSE_SUCCESS = "TM_CREATE_COURSE_SUCCESS";
export const TM_CREATE_COURSE_FAILURE = "TM_CREATE_COURSE_FAILURE";

export const TM_COURSES_REQUEST = "TM_COURSES_REQUEST";
export const TM_COURSES_SUCCESS = "TM_COURSES_SUCCESS";
export const TM_COURSES_FAILURE = "TM_COURSES_FAILURE";
export const TM_UPDATE_COURSE_REQUEST = "TM_UPDATE_COURSE_REQUEST";
export const TM_UPDATE_COURSE_SUCCESS = "TM_UPDATE_COURSE_SUCCESS";
export const TM_UPDATE_COURSE_FAILURE = "TM_UPDATE_COURSE_FAILURE";
export const TM_CLEAR_TEACHERS_ERROR = "TM_CLEAR_TEACHERS_ERROR";
export const TM_CLEAR_CREATE_ERROR = "TM_CLEAR_CREATE_ERROR";
export const TM_CLEAR_COURSES_ERROR = "TM_CLEAR_COURSES_ERROR";
export const TM_CLEAR_CREATE_SUCCESS = "TM_CLEAR_CREATE_SUCCESS";
export const TM_CLEAR_UPDATE_STATE = "TM_CLEAR_UPDATE_STATE";

export const fetchTeachersWithAccess = () => async (dispatch) => {
  dispatch({ type: TM_TEACHERS_REQUEST });
  try {
    const res = await api.get("/teachers/teachers-with-access");
    dispatch({ type: TM_TEACHERS_SUCCESS, payload: res.data });
  } catch (e) {
    dispatch({
      type: TM_TEACHERS_FAILURE,
      payload: e?.response?.data?.message || e.message,
    });
  }
};

export const fetchTeacherManagerCourses = () => async (dispatch) => {
  dispatch({ type: TM_COURSES_REQUEST });
  try {
    const res = await api.get("/teachers/teachers-created-courses");
    dispatch({ type: TM_COURSES_SUCCESS, payload: res.data });
  } catch (e) {
    dispatch({
      type: TM_COURSES_FAILURE,
      payload: e?.response?.data?.message || e.message,
    });
  }
};

export const createTeacherCourseByManager = (payload) => async (dispatch) => {
  dispatch({ type: TM_CREATE_COURSE_REQUEST });
  try {
    const res = await api.post("/teachers/teacher-manager-courses", payload);
    dispatch({ type: TM_CREATE_COURSE_SUCCESS, payload: res.data });
  } catch (e) {
    dispatch({
      type: TM_CREATE_COURSE_FAILURE,
      payload: e?.response?.data?.message || e.message,
    });
  }
};

export const updateTeacherCourseByManager = (teacherCourseId, payload) => async (dispatch) => {
  dispatch({ type: TM_UPDATE_COURSE_REQUEST });
  try {
    const res = await api.put(
      `/teachers/teacher-update-courses/${teacherCourseId}`,
      payload
    );
    dispatch({ type: TM_UPDATE_COURSE_SUCCESS, payload: res.data });
  } catch (e) {
    dispatch({
      type: TM_UPDATE_COURSE_FAILURE,
      payload: e?.response?.data?.message || e.message,
    });
  }
};

export const clearTeacherManagerTeachersError = () => ({
  type: TM_CLEAR_TEACHERS_ERROR,
});

export const clearTeacherManagerCreateError = () => ({
  type: TM_CLEAR_CREATE_ERROR,
});

export const clearTeacherManagerCoursesError = () => ({
  type: TM_CLEAR_COURSES_ERROR,
});

export const clearTeacherManagerCreateSuccess = () => ({
  type: TM_CLEAR_CREATE_SUCCESS,
});

export const clearTeacherManagerUpdateState = () => ({
  type: TM_CLEAR_UPDATE_STATE,
});
